const protectedEnv = (key: string) => {
  const val = process.env[key] as any
  if (!val) {
    throw new Error(`${key} is not provided`)
  }
  return val
}

export const YANDEX_MAP_KEY = protectedEnv('REACT_APP_YANDEX_MAP_KEY')
export const REACT_APP_STATIC_YMAPS_KEY = protectedEnv('REACT_APP_STATIC_YMAPS_KEY')
export const DOMAIN_TYPE = protectedEnv('REACT_APP_DOMAIN_TYPE')
export const MAINTENANCE_MODE = protectedEnv('REACT_APP_MAINTENANCE_MODE')

// Опциональные переменные для локальной разработки
export const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED !== 'false'
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/rest_api'
